import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import DS from 'ember-data';
import RouterService from '@ember/routing/router-service';
import AlertsService from 'cio/services/alerts';
import AuthService from 'cio/services/auth';
import VerifyService from 'cio/services/verify';
import WebhookModel from 'cio/models/webhook';

const MAX_WEBHOOKS = 10;

export default class IntegrationsReportingWebhooksIndex extends Controller {
  @service store!: DS.Store;
  @service alerts!: AlertsService;
  @service auth!: AuthService;
  @service verify!: VerifyService;
  @service router!: RouterService;

  declare model: WebhookModel[];

  get canAdd() {
    return this.auth.hasPermission('journeys/reporting_webhooks/edit');
  }

  @computed('model.length')
  get isAddDisabled() {
    return this.model.length === MAX_WEBHOOKS || !this.canAdd;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'integrations/reporting-webhooks/index': IntegrationsReportingWebhooksIndex;
  }
}
